// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"gn_a pz_cv pz_je pz_iu pz_a pz_j pz_oa pz_ob","SearchPanel__icon":"gn_b pz_qz pz_gs pz_oh pz_qn","SearchPanel__input":"gn_c pz_ie pz_cw pz_z"};